import React from "react";

import { mdiLoading } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import type { JSX } from "react";

function CalendarSchedulingModalLoading(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  return (
    <div className="flex flex-col items-center justify-center gap-[0.9375rem] p-[0.9375rem]">
      <div className="flex flex-col items-center justify-center gap-[0.46875rem]">
        <div className="text-[1.171875rem] font-medium">
          {t("processingInProgress")}
        </div>
        <div className="font-medium">({t("pleaseWaitFewSecnds")})</div>
      </div>
      <Icon spin path={mdiLoading} size={6.25} />
    </div>
  );
}

export default CalendarSchedulingModalLoading;
